import { Map, Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const DisplayCacheRecord = Record({
  itemDates: Map(),
  // TODO: Currently itemDates data is merged into displayItems data, so it is duplicated
  // Eventually we want to remove this so that there is only one copy of the data
  displayItems: Map(),
  lastTodayDate: null,
  validatedDateConstraints: Map(),
  validatedDependencies: Map(),
  // Calculate and store card sizes for each view type
  viewCardSizes: Map()
});

const data = {
  objects: {
    lastTodayDate: "DateRecord"
  },
  collections: {
    itemDates: "ItemDatesRecord",
    displayItems: "ItemDisplayRecord",
    validatedDateConstraints: "ValidatedConstraintRecord",
    validatedDependencies: "ValidatedDependencyRecord",
    viewCardSizes: "ViewCardSizesRecord"
  }
};

createFromJS.registerCallback("DisplayCacheRecord", createFromJS.createNestedCallback(DisplayCacheRecord, data));
